"use strict";

var _regeneratorRuntime = require("/codebuild/output/src133026617/src/hopin-web/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/codebuild/output/src133026617/src/hopin-web/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _ = _interopRequireDefault(require("../"));

var _gsap = _interopRequireDefault(require("gsap"));

var _jsxFileName = "/Users/tyler/Documents/GitHub/gatsby-plugins/transition-link/gatsby-plugin-transition-link/src/AniLink/MorphTo.js";

var MorphTo = function MorphTo(_ref) {
  var children = _ref.children,
      to = _ref.to,
      duration = _ref.duration,
      morph = _ref.morph;
  return /*#__PURE__*/_react.default.createElement(_.default, {
    to: to,
    exit: {
      length: duration
    },
    entry: {
      appearAfter: duration
    },
    trigger: function () {
      var _trigger = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(pages) {
        var exit, entry, morphFromEl, morphToEl, finalMeasurements;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return pages.exit;

              case 2:
                exit = _context.sent;
                _context.next = 5;
                return pages.entry;

              case 5:
                entry = _context.sent;
                morphFromEl = exit.node.querySelector(morph.from);
                morphToEl = entry.node.querySelector(morph.to);
                finalMeasurements = {
                  height: morphToEl.offsetHeight,
                  width: morphToEl.offsetWidth
                };

                _gsap.default.to(morphFromEl, {
                  width: finalMeasurements.width,
                  height: finalMeasurements.height,
                  duration: duration
                });

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function trigger(_x) {
        return _trigger.apply(this, arguments);
      }

      return trigger;
    }(),
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6,
      columnNumber: 2
    }
  }, children);
};

var _default = MorphTo;
exports.default = _default;